import { ServiceRequestApi } from '../ServiceRequestApi';
import Dict from '../../../modules/utils/Dict';
import Notice from '../../../modules/utils/Notice';
import i18next from 'i18next';
import moment from 'moment';
import { handleError } from '../../../modules/utils/handleError';

export const CheckChildInQueue = async (t, child_iin, queue_type) => {
  try {
    let check = false;

    const checkActiveQueue = await ServiceRequestApi.checkActiveQueue(
      child_iin,
      queue_type
    );
    const responseDirection = await ServiceRequestApi.checkQueueByIin(
      child_iin,
      queue_type
    );

    const responseVoucher = await ServiceRequestApi.checkVoucherQueueByIin(
      JSON.stringify({
        childIin: child_iin,
        queuedType: queue_type,
        isActive: null,
        isArchived: false
      })
    );

    if (
      checkActiveQueue.data.status === 'SUCCESS' &&
      checkActiveQueue.data.result.length > 0
    ) {
      for (let i = 0; i < checkActiveQueue.data.result.length; i++) {
        let item = checkActiveQueue.data.result[i];
        switch (item.appStatus) {
          case 'ON_CHECK':
            check = true;
            let app_status = await Dict.item('gu_app_status', item.appStatus);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err1', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                app_status: app_status[`${i18next.language}_name`]
              })
            );
            break;

          case 'ASSIGN_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err5', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                req_form_id: item.requestFormId,
                child_iin: item.childIin
              })
            );
            break;
          case 'IN_QUEUED':
            check = true;
            let q_type = await Dict.item('gu_queued_type', item.queuedType);
            let p_queued = await Dict.item('gu_priority_queued', item.priorityQueued);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: q_type[`${i18next.language}_name`],
                priority_queued: p_queued[`${i18next.language}_name`]
              })
            );
            break;
          case 'WAITING_ASSIGN':
            check = true;
            let queue_type = await Dict.item('gu_queued_type', item.queuedType);
            let priority_queued = await Dict.item(
              'gu_priority_queued',
              item.priorityQueued
            );
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: queue_type[`${i18next.language}_name`],
                priority_queued: priority_queued[`${i18next.language}_name`]
              })
            );
            break;

          case 'STOP_LIST_DC':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err4', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                deadline_stop_list: item.deadlineStopList
                  ? moment(item.deadlineStopList).format('DD.MM.YYYY')
                  : '__.__.____'
              })
            );
            break;

          case 'RECEIVED_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err7', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),

                req_form_id: item.requestFormId,
                child_iin: child_iin,
                id: item.id
              })
            );

            break;

          case 'WAITING_CONFIRM_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err5', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                req_form_id: item.requestFormId,
                child_iin: item.childIin
              })
            );

            break;
          default:
        }
        if (check) {
          break;
        }
      }
    } else if (
      responseDirection.data.status === 'SUCCESS' &&
      responseDirection.data.result.length > 0
    ) {
      for (let i = 0; i < responseDirection.data.result.length; i++) {
        let item = responseDirection.data.result[i];
        switch (item.appStatus) {
          case 'ON_CHECK':
            check = true;
            let app_status = await Dict.item('gu_app_status', item.appStatus);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err1', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                app_status: app_status[`${i18next.language}_name`]
              })
            );
            break;
          case 'IN_QUEUED':
          case 'WAITING_PRIORITY':
          case 'PRIORITY_ACCESS':
            check = true;
            let q_type = await Dict.item('gu_queued_type', item.queuedType);
            let p_queued = await Dict.item('gu_priority_queued', item.priorityQueued);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: q_type[`${i18next.language}_name`],
                priority_queued: p_queued[`${i18next.language}_name`]
              })
            );
            break;
          case 'DIRECTION_RECEIVED':
          case 'DIRECTION_PROLONGED':
            check = true;
            let dir_date = '__.__.____';
            dir_date = moment(item.directionDate).format('DD.MM.YYYY');
            // if (item.directionId) {
            //   console.log('here');
            //   const dir_res = await ServiceRequestApi.getDirection(
            //     JSON.stringify({ id: item.directionId })
            //   );
            //   const direction = dir_res.data.result.content;
            //   if (direction.length > 0) {
            //     dir_id = direction[0].id;
            //     if (direction[0].directionDate) {
            //       dir_date = moment(direction[0].directionDate).format('DD.MM.YYYY');
            //     }
            //   }
            // }
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err3', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                dir_id: item.directionId,
                dir_date: dir_date
              })
            );
            break;
          case 'STOP_LIST_DC':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err4', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                deadline_stop_list: item.deadlineStopList
                  ? moment(item.deadlineStopList).format('DD.MM.YYYY')
                  : '__.__.____'
              })
            );
            break;

          default:
        }
        if (check) {
          break;
        }
      }
    } else if (
      responseVoucher.data.status === 'SUCCESS' &&
      responseVoucher.data.result.content.length > 0
    ) {
      for (let i = 0; i < responseVoucher.data.result.content.length; i++) {
        let item = responseVoucher.data.result.content[i];
        switch (item.appStatus) {
          case 'ON_CHECK':
            check = true;
            let app_status = await Dict.item('gu_app_status', item.appStatus);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err1', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                app_status: app_status[`${i18next.language}_name`]
              })
            );
            break;
          case 'IN_QUEUED':
            check = true;
            let q_type = await Dict.item('gu_queued_type', item.queuedType);
            let p_queued = await Dict.item('gu_priority_queued', item.priorityQueued);
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err2', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                queued_type: q_type[`${i18next.language}_name`],
                priority_queued: p_queued[`${i18next.language}_name`]
              })
            );
            break;

          case 'STOP_LIST_DC':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err4', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                child_iin: item.childIin,
                req_form_id: item.requestFormId,
                deadline_stop_list: item.deadlineStopList
                  ? moment(item.deadlineStopList).format('DD.MM.YYYY')
                  : '__.__.____'
              })
            );
            break;

          case 'ASSIGN_VOUCHER':
            check = true;
            Notice.error(
              i18next.t('serviceRequest_check_in_queue_err5', {
                fio:
                  (item?.childSurname || '') +
                  ' ' +
                  (item?.childName || '') +
                  ' ' +
                  (item?.childMiddleName || ''),
                req_form_id: item.requestFormId,
                child_iin: item.childIin
              })
            );

            break;
          default:
        }
        if (check) {
          break;
        }
      }
    } else if (
      responseVoucher.data.status === 'SUCCESS' &&
      responseVoucher.data.result.content.length === 0
    ) {
      const voucher_res = await ServiceRequestApi.getVoucherStatus(
        JSON.stringify({ childIin: child_iin, queuedType: queue_type })
      );

      for (let i = 0; i < voucher_res.data.result.content.length; i++) {
        let voucher = voucher_res.data.result.content[i];

        if (voucher.status === 'RECEIVED' || voucher.status === 'ARRIVED_TO_PO') {
          Notice.error(
            i18next.t('serviceRequest_check_in_queue_err6', {
              fio:
                (voucher?.childSurname || '') +
                ' ' +
                (voucher?.childName || '') +
                ' ' +
                (voucher?.childMiddleName || ''),

              req_form_id: voucher.requestFormId,
              child_iin: child_iin,
              id: voucher.id
            })
          );
          check = true;
        }
      }
    } else {
      Notice.error(i18next.t('serviceRequest_queue_type_check_req_err'));
    }
    return check;
  } catch (e) {
    handleError(e, t('gbdflButton_searchFailed'));
    return false;
  }
};
